import Box from '@cloudscape-design/components/box';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Table from '@cloudscape-design/components/table';
import React from 'react';

interface ParticipantEventDetailsProps {
    eventsDetails: {
        eventName: string;
        stage: string;
        time: string;
    }[]
}

export const ParticipantEventDetails: React.FC<ParticipantEventDetailsProps> = ({
    eventsDetails
}) => {
    return (
        <Table
            columnDefinitions={[
                {
                    id: "event",
                    header: "Event",
                    cell: item => item.eventName || "-",
                    sortingField: "name",
                    isRowHeader: true
                },
                {
                    id: "stage",
                    header: "Stage",
                    cell: item => item.stage || "-"
                },
                {
                    id: "time",
                    header: "Time slot",
                    cell: item =>  {
                        return item?.time || "-"
                    }
                }
            ]}
            items={eventsDetails}
            loadingText="Loading event details"
            sortingDisabled
            empty={
                <Box
                    margin={{ vertical: "xs" }}
                    textAlign="center"
                    color="inherit"
                >
                    <SpaceBetween size="m">
                        <b>No details found</b>
                    </SpaceBetween>
                </Box>
            }
            header={<Header> Event details </Header>}
        />
    )
};